import React from 'react';
import { Box, Checkbox, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import SingleDatePickerMAIQ from 'app/components/SingleDatePickerMAIQ';
import { PickDateFilterType } from '../apiService/runLogsApiService';

export interface NurturingDateFilterControlsProps {
  showAllOption?: boolean;
  isAllChecked?: boolean;
  onAllCheckedChange?: (checked: boolean) => void;
  dateFilterType: Exclude<PickDateFilterType, 'ALL'> | null;
  onDateFilterTypeChange: (filterType: Exclude<PickDateFilterType, 'ALL'> | null) => void;
  startDate: string | null;
  onStartDateChange: (date: string | null) => void;
  endDate: string | null;
  onEndDateChange: (date: string | null) => void;
  disabled?: boolean;
  maxDate?: string | Date | null;
}

export function NurturingDateFilterControls({
  showAllOption = false,
  isAllChecked = false,
  onAllCheckedChange,
  dateFilterType,
  onDateFilterTypeChange,
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
  disabled = false,
  maxDate = null,
}: NurturingDateFilterControlsProps) {
  const isSinceDate = dateFilterType === 'SINCE_DATE';
  const isDateRange = dateFilterType === 'DATE_RANGE';

  return (
    <>
      {showAllOption && (
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={isAllChecked}
              onChange={e => onAllCheckedChange?.(e.target.checked)}
            />
          }
          label="All"
        />
      )}

      <RadioGroup
        row
        value={dateFilterType ?? ''}
        onChange={e =>
          onDateFilterTypeChange(
            (e.target.value as Exclude<PickDateFilterType, 'ALL'> | '') || null,
          )
        }
        sx={{ mb: 1 }}
      >
        <FormControlLabel value="" control={<Radio size="small" />} label="None" />
        <FormControlLabel value="SINCE_DATE" control={<Radio size="small" />} label="Since Date" />
        <FormControlLabel value="DATE_RANGE" control={<Radio size="small" />} label="Date Range" />
      </RadioGroup>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5 }}>
        {(isSinceDate || isDateRange) && (
          <SingleDatePickerMAIQ
            value={startDate}
            onChange={onStartDateChange}
            label="Start Date"
            disabled={disabled}
            maxDate={maxDate}
            fullWidth={false}
          />
        )}

        {isDateRange && (
          <SingleDatePickerMAIQ
            value={endDate}
            onChange={onEndDateChange}
            label="End Date"
            disabled={disabled}
            maxDate={maxDate}
            fullWidth={false}
          />
        )}
      </Box>
    </>
  );
}

export default NurturingDateFilterControls;

